import { designService } from '@paragon/data-connections';

import {
  plateOptionsFailedLoading,
  plateOptionsFinishedLoading,
  plateOptionsStartedLoading,
} from '../store/plateOptionsSlice';
import { AsyncThunkActionVoid } from './thunkActionTypes';

export const loadPlateOptions = (): AsyncThunkActionVoid => async (dispatch) => {
  dispatch(plateOptionsStartedLoading());

  try {
    const platePairs = await designService.materialLists.getPlateOptions();
    dispatch(plateOptionsFinishedLoading(platePairs));
  } catch (error: any) {
    dispatch(plateOptionsFailedLoading(error.message ?? ''));
  }
};
